export default __webpack_public_path__ + "static/media/iconeIncluirGrupoMaior.a63a1f9d.png";